<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElLoading } from 'element-plus';
import request from '@/utils/request';
import { Download } from '@element-plus/icons-vue';
import { useRouter, useRoute } from 'vue-router';
import StudentReview from '@/views/component/StudentReview.vue';  
import PageHeader from '@/components/PageHeader.vue';
import WorkDetail from '@/views/component/WorkDetail.vue'
import { getWorkDetails, getStigProjectWorkDetails } from '@/utils/api.js';

const revirwer_type = JSON.parse(localStorage.getItem('user')).reviewer_type;
console.log('revirwer_type:', revirwer_type)

const route = useRoute()

const tableData = ref({})
const workDetail = ref({})
const dynamicValidateForm = reactive({
  tables: []
})

const fn = revirwer_type === 'kechuang' ? getStigProjectWorkDetails : getWorkDetails
const workStatus = ref('')
onMounted(() => {
  fn(route.query.id).then(res => {
    console.log('获取我的作品详情', res)
    workStatus.value = res.data.submit_status
    console.log('workStatus', workStatus.value) 
    tableData.value = res.data.form_data
    dynamicValidateForm.tables = res.data.form_template
    workDetail.value = {
      work_name: res.data.title,
      work_description: res.data.description,
      contestant_name: res.data.contestant_name,     
    }
  })
})


const dialogVisible = ref(false);
const currentProject = ref({
  id: 1,
  projectName: '我的创客',
  author: '作者1',
  description: '这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目这是一个项目',
  category: '分类1',
  submitTime: '2023-01-01',
  group: '组1',
  isPhysicalObject: '非实物',
  status: '待评审',
  imageUrl: 'https://www.cnmaker.org.cn/resource/images/product_img.png',
});
const reviewFormRef = ref();

// 评审表单数据
const reviewForm = reactive({
  studentId: '',
  name: '',
  realScore: 0,
  noveltyScore: 0,
  scienceScore: 0,
  guideScore: 0,
  rigorScore: 0,
  comment: ''
});



// 评审表单验证规则
const reviewRules = {
  realScore: [
    { required: true, message: '请给出评分', trigger: 'change' },
    // { max: 20, message: '最大分值20分', trigger: 'blur' }
  ],
  noveltyScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  scienceScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  guideScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  rigorScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  comment: [
    // { required: true, message: '请输入评审意见', trigger: 'blur' },
    { min: 20, message: '评审意见至少 20 个字符', trigger: 'blur' }
  ],
  studentId: [
    { required: true, message: '请输入学生ID', trigger: 'blur' }
  ],
  name: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  reviewer_name: [
    { required: true, message: '请输入专家签名', trigger: 'blur' }
  ],
};


// // 加载待评审项目
// const loadPendingProjects = async () => {
//   loading.value = true;
//   try {
//     const data = await request.get('/projects/pending-review');
//     pendingProjects.value = data;
//   } catch (error) {
//     ElMessage.error('加载待评审项目失败: ' + (error.message || '未知错误'));
//   } finally {
//     loading.value = false;
//   }
// };

// 提交评审
const submitReview = async () => {
  if (!currentProject.value) return;


  try {
    await reviewFormRef.value.validate();
  } catch (validationError) {
    console.log('表单验证失败:', validationError);
    return;
  }

  // 显示加载
  const loading = ElLoading.service({
    lock: true,
    text: '正在提交评审...',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  
  try {
    // await request.post(`/projects/${currentProject.value.id}/review`, {
    await request.post(`/activity/review`, {
      rigorScore: reviewForm.rigorScore,
      realScore: reviewForm.realScore,
      noveltyScore: reviewForm.noveltyScore,
      scienceScore: reviewForm.scienceScore,
      guideScore: reviewForm.guideScore,
      comment: reviewForm.comment,
      work_id: route.query.id,
      work_status: workStatus.value,
      reviewer_name: reviewForm.reviewer_name,
    });
    
    // 关闭加载
    loading.close();
    ElMessage.success('评审提交成功！');
    // dialogVisible.value = false;
    router.go(-1)
    
    // 重新加载待评审项目
    // loadPendingProjects();
  } catch (error) {
    // 验证失败不处理
    console.log('提交评审失败:', error)
    // ElMessage.error('提交评审失败: ' + (error.message || '未知错误'));
    loading.close(); 
  }
};



// 下载文件
const downloadFile = async (fileUrl) => {
  if (!fileUrl) return;
  
  try {
    const response = await request.get(fileUrl, {
      responseType: 'blob'
    });
    
    // 创建下载链接
    const url = window.URL.createObjectURL(new Blob([response]));
    const a = document.createElement('a');
    a.href = url;
    
    // 从URL中提取文件名
    const fileName = fileUrl.split('/').pop();
    a.download = fileName;
    
    document.body.appendChild(a);
    a.click();
    
    // 清理
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    ElMessage.error('下载失败: ' + (error.message || '未知错误'));
  }
};

const router = useRouter();
const back = () => {
  router.go(-1)
}


const totalScore = computed(() => {
  return reviewForm.realScore + reviewForm.noveltyScore + reviewForm.scienceScore + reviewForm.guideScore + reviewForm.rigorScore;
});


const srcList = ref([
  'https://www.aixlab.cn/images/cover/AI.jpeg',
  'https://www.cnmaker.org.cn/resource/images/product_img.png'
])


const showViewer = ref(false)
const viewerIndex = ref(0)

const openImageViewer = (index) => {
  viewerIndex.value = index
  showViewer.value = true
}

</script>



<template>
  <div class="header">
    <el-page-header @back="back" title="列表" style="margin-top: 8px;">
      <template #content>
        <span style="font-size: 15px;"> 
          {{ router.currentRoute.value.meta.title }} 
        </span>
      </template>
    </el-page-header>
  </div>
  <div class="container">
    <el-row>
      <el-col :span="12" style="border-right: 1px solid #ccc;">
        <div class="left">
          <el-scrollbar style="padding-right: 20px;color: #696969;" :always="false">
            <WorkDetail :workDetail="workDetail" :dynamicForm="dynamicValidateForm.tables" 
              :tableData="tableData" />
        
            <!-- <el-steps :active="2" align-center style="margin-top: 50px;">
              <el-step title="待审核">
                <template #description>
                  <div>作品待审核</div>
                  <div>2002/08/05 12:22</div>
                </template>
              </el-step>
              <el-step title="初审" description="专家进行初审" />
              <el-step title="初审完成" description="初审完成，等待复审" />
              <el-step title="复审" description="专家进行复审" />
              <el-step title="复审完成" description="复审完成，作品已被评审" />
            </el-steps> -->
          </el-scrollbar>
        </div>
      </el-col>


      <el-image-viewer
        v-if="showViewer"
        :url-list="srcList"
        :initial-index="viewerIndex"
        @close="showViewer = false"
      />



      <el-col :span="12">
        <!-- <StudentReview /> -->
        <div class="right">
          <el-scrollbar style="padding-right: 20px;color: #696969;" :always="false">
          <h2 style="color: #0095ff;text-align: center;margin-bottom: 25px;" v-if="true"> 
            <span>专家评审表</span>
          </h2>
          <!-- <h2 style="color: #0095ff;text-align: left;" v-else> 
            <span >感兴趣可参与打分哦</span>
          </h2> -->

          <div v-if="false">
            <div class="text"><strong>1.作品类别:</strong></div>
            <div class="text">(1)前沿探究类包括对某一原理、实验、公式、模型等数学理论的研究。</div>
            <div class="text">(2)问题解决类包括对某一社会或生活中的问题，利用数学方法推进解决。</div>
            <div class="text">(3)创意表达类包括对某一主题通过绘画、摄影、PPT等形式，进行新颖奇特、富有想象力的表达。</div>
            <div class="text">(4)游戏表演类包括对某一主题通过游戏、音乐、舞蹈等形式的创新(全部或部分原创)演绎.</div>
            <div><strong>2.等级</strong>:&nbsp;&nbsp;优秀:100-90分:良好:89-75分:一股:74分以下。</div>
            <el-divider />
          </div>

          <!-- <div style="font-size: 15px;margin-bottom: 20px;">
            <p style="font-size: 18px;"><strong>作品成绩记录</strong></p>
            整体评价:
            <div>(1)创意的真实性:创意源于日常生活，真实、易见，基于学生的兴趣、爱好;</div>
            <div>(2)创意的新颖性:1创意新颖、独特、形象、简洁;</div>
            <div>(3)创意的科学性:蕴含着科学规律，与科学知识紧密关联;</div>
            <div>(4)激发引导作用:创意具有开放性，能激发观者思考、产生新的创意;</div>
            <div>(5)表达的严谨性:工艺先进，所使用的材料易获得、低成本，节能环保。</div>
          </div> -->
          

          <el-form :model="reviewForm" :rules="reviewRules" ref="reviewFormRef" style="margin-top: 20px;"
            label-width="150px" label-suffix="：" class="internal-review-form"
          >
            <div style="display: flex;justify-content: start;align-items: center;">
              <div>
                <el-form-item label="创意的真实性" prop="realScore">
                  <el-input-number v-model="reviewForm.realScore" :min="0" :max="20" @change="handleChange" />
                  <span style="color: #696969;">（0-20分）</span>
                </el-form-item>
                <el-form-item label="创意的新颖性" prop="noveltyScore">
                  <el-input-number v-model="reviewForm.noveltyScore" :min="0" :max="20" @change="handleChange" />
                  <span style="color: #696969;">（0-20分）</span>
                </el-form-item>
                <el-form-item label="创意的科学性" prop="scienceScore">
                  <el-input-number v-model="reviewForm.scienceScore" :min="0" :max="20" @change="handleChange" />
                  <span style="color: #696969;">（0-20分）</span>
                </el-form-item>
                <el-form-item label="激发引导作用" prop="guideScore">
                  <el-input-number v-model="reviewForm.guideScore" :min="0" :max="20" @change="handleChange" />
                  <span style="color: #696969;">（0-20分）</span>
                </el-form-item>
                <el-form-item label="表达的严谨性" prop="rigorScore">
                  <el-input-number v-model="reviewForm.rigorScore" :min="0" :max="20" @change="handleChange" />
                  <span style="color: #696969;">（0-20分）</span>
                </el-form-item>
              </div>
              <div style="margin-left: 100px;width: 100px; height: 100px;display: grid;place-items: center;
                border-radius: 50%;background: #e9edf5;">
                <!-- 总分: {{ totalScore }} -->
                <el-statistic title="总分:" :precision="0" :value="totalScore" />
              </div>
            </div>
              
            <el-form-item label="评审意见" prop="comment">
              <el-input 
                v-model="reviewForm.comment" 
                type="textarea" 
                rows="6"
                placeholder="请输入评审意见..."
              ></el-input>
            </el-form-item>

            <el-form-item label="专家签名" prop="reviewer_name">
              <el-input v-model="reviewForm.reviewer_name" placeholder="请输入专家签名" />
            </el-form-item>

            <div v-if="false">
              <el-form-item label="学号" prop="studentId">
                <el-input v-model="reviewForm.studentId" placeholder="请输入学号" />
              </el-form-item>
              <el-form-item label="姓名" prop="name">
                <el-input v-model="reviewForm.name" placeholder="请输入姓名" />
              </el-form-item>
            </div>
          
            <el-form-item>
              <el-button @click="()=>{
                router.go(-1)
              }">取消</el-button>
              <el-button type="primary" @click="submitReview">
                提交评审
              </el-button>
            </el-form-item>
          </el-form>
          <!-- <el-divider /> -->
          
          </el-scrollbar>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.container{
  margin: 20px;
  flex: 1;
  /* background: #fff; */
}

.header{
  /* background: #fff; */
  border-bottom: 1px solid #f2eeee;
  padding-bottom: 5px;
  padding-left: 10px;
}

.left{
  margin-left: 10px;
  /* padding-right: 20px; */
  position: relative;
  height: calc(100vh - 150px);
  overflow-y: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  /* background: transparent; */
  /* background: #fff; */
}

/* .file-download{
  font-size: 20px;
} */

.right{
  margin-left: 20px;
  height: calc(100vh - 150px);
  overflow-y: auto;

  .text{
    margin-bottom: 5px;
  }
}


:deep(.el-statistic){
  text-align: center;
}
</style>